import { Styles } from "react-joyride";

export const tourStyles: Partial<Styles> = {
  options: {
    zIndex: 1100,
    primaryColor: "var(--ciq-primary-900)",
    textColor: "var(--ciq-primary-900)",
    arrowColor: "#ffffff",
    backgroundColor: "#ffffff",
    overlayColor: "rgba(0, 0, 0, 0.5)"
  },
  tooltip: {
    borderRadius: 6,
    padding: 16
  },
  tooltipTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 8
  },
  tooltipContent: {
    fontSize: 14,
    padding: 0,
    lineHeight: 1.5
  },
  buttonNext: {
    borderRadius: 4,
    fontSize: 13,
    padding: "6px 14px"
  },
  buttonBack: {
    fontSize: 13,
    marginRight: 8
  },
  buttonSkip: {
    fontSize: 13
  }
};

export const tourLocale = {
  back: "Back",
  close: "Close",
  last: "Done",
  next: "Next",
  skip: "Skip"
};
